/* FormsMultiEditComponent.js */

"use strict";

const FormsComponent = require("./FormsComponent");
const Renderer = require("./FormsMultiEditRenderer");

class FormsMultiEditComponent extends FormsComponent {
    constructor(...args) {
        super(...args);
        this._renderer = new Renderer(this);
    }
    getFormValue() {
        return this._renderer.getFormValue();
    }
    getNonSelectedPaths(path) {
        return this._renderer.getNonSelectedPaths(path);
    }
}

module.exports = FormsMultiEditComponent;
